import { fontWeights } from "@/utils/fonts";
import AllIconsComponent from "../custom-icons/AllIconsComponent";

interface IndustryCardProps {
  title: string;
  description: string;
  icon: string;
  iconWidth: string;
  iconHeight: string;
}

export function IndustryCard({ title, description, icon: Icon, iconWidth, iconHeight }: IndustryCardProps) {
  return (
    <div
      className="
    bg-white 
    py-[3rem]
    sm:py-8
    lg:py-[3rem]
    p-2
    sm:p-4
    xl:p-5 
    rounded-[10px] 
    flex 
    flex-col
    items-center 
    text-center 
    group 
    hover:shadow-lg 
    transition-shadow 
    duration-300 
    w-auto 
    tsm-400:w-[370px]
    sm:w-[600px]
    lg:w-[320px]
    xl:w-[400px]
    max-w-[800px]
    h-auto
    lg:h-[290px]
    xl:h-[320px]
    max-h-[500px] 
    "
    >
      <div className="lg:mb-6 mb-4">
        <h3
          className="
        text-[17px]
        lg:text-[20px] 
        xl:text-[24px]  
        text-[#002F6D] 
        mb-4
        lg:mb-5
        xl:mb-10
        "
          style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.semiBold }}
        >
          {title}
        </h3>
        <div
          className="
        w-12
        xl:w-16
        h-12
        xl:h-16 
        flex 
        items-center 
        justify-center 
        mx-auto"
        >
          <AllIconsComponent iconName={Icon} width={iconWidth} height={iconHeight} color="#000000" />
        </div>
      </div>
      <div
        className="
      border-t-2 
      border-[#FFA500] 
      w-[130px]
      tsm-350:w-[280px]
      tsm-400:w-[320px]
      sm:w-[500px]
      lg:w-[240px] 
      xl:w-[300px] 
      max-w-[500px] 
      mb-5
      lg:mb-7
      "
      />
      <p
        className="
      text-[#000000] 
      leading-5
      text-[14px] 
      lg:text-[17px] 
      2xl:text-[18px]
      px-10
      tsm-350:px-6
      lg:px-0
      "
        style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.regular }}
      >
        {description}
      </p>
    </div>
  );
}
